<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Affordable Housing, Community Development + Public Finance
    </Heading>
    <p>
      We have represented non-profit developers, for-profit developers and
      investors in connection with their acquisition, rehabilitation,
      construction, development and financing of apartment communities and
      mixed-use projects throughout the United States. We understand that deals
      now require significant layering of complex debt structures, equity and
      regulatory requirements. Our clients have used tax-exempt bonds, taxable
      bonds, state and local loans, subordinate loans, and long-term financings.
      We advise developers on the wide range of issues that arise during the
      course of structuring multifamily transactions, such as joint ventures and
      other forms of entity structuring, leveraging low income housing tax
      credit, historic tax credit, and new markets tax credit equity, public
      disclosure requirements, real estate issues and regulatory issues, as well
      as state-specific concerns such as land use and planning law, subdivision
      matters, community redevelopment law and California Constitution Article
      XXXIV matters. Our team has extensive experience negotiating loan, bond
      and tax credit documents with bond issuers, bond counsel, the credit
      enhancer and the tax credit investor. We are also actively involved in
      dealings with the committee members and staff of the California Tax Credit
      Allocation Committee and the California Debt Limit Allocation Committee.
    </p>
    <p>
      An important aspect of our public finance practice is the depth of our tax
      law experience. We maintain contact with Internal Revenue Service and
      Treasury Department officials in order to stay up to date on tax issues
      facing the public finance industry. We are experienced in all federal and
      state tax aspects of affordable housing development with a special
      emphasis on taxation of partnerships and partners, nonprofit
      organizations, low income housing tax credits, historic tax credits, new
      markets tax credits, and transfer taxation of real estate. We understand
      the critical tax nature of the 10% test, compliance with the minimum
      set-aside, tax credit recapture during the compliance period, deferred
      developer fees, special allocations of partnership income and loss,
      tax-exempt status, and property tax abatement. We routinely work to
      develop creative and sound deal structures to address these issues. We
      routinely provide guidance to clients on issues regarding credit
      enhancement, securitization and defeasance.
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
